
import { onBeforeMount, ref, defineComponent } from "vue";
interface imgListProp {
  name: string;
  src: string;
  title?: string;
}

const hadelInput = () => {
  const inputVla = ref("");
  return inputVla;
};

export default defineComponent({
  data() {
    return {
      height: "",
      color: "purple",
    };
  },

  methods: {
    getHeight() {
      this.height = this.height = (window.innerWidth * 2842) / 4997 - 50 + "px";
    },
  },
  mounted() {
    let div10 = document.getElementById("div10");
    setTimeout(() => {
      if (div10 != null) div10.style.transform = "translate(0, 0)";
    }, 100);

    let div11 = document.getElementById("div11");
    setTimeout(() => {
      if (div11 != null) div11.style.transform = "translate(0, 0)";
    }, 100);

    let div12 = document.getElementById("div12");
    setTimeout(() => {
      if (div12 != null) div12.style.transform = "translate(0, 0)";
    }, 100);

    this.getHeight();
  },
  setup() {
    let imgList = ref<imgListProp[] | null>(null);
    const result = hadelInput();
    onBeforeMount(() => {
      imgList.value = [
        {
          name: "v1",
          src: require("../assets/images/carousel4.jpg"),
          title: "v1",
        },
        {
          name: "v1",
          src: require("../assets/images/carousel5.jpg"),
          title: "v1",
        },
      ];
    });
    return { result, imgList };
  },
});
